// extracted by css-extract-rspack-plugin
export default {"widget":"JlLaA","container":"oUjLQ","tableBar":"OS9vB","inputContainer":"IzK_3","submitButton":"EuCOY","cancelButton":"K2JIr"};